var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenderMaleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.5C10 2.01562 7.76042 0 5 0C2.23958 0 0 2.01562 0 4.5C0 6.81563 1.94444 8.725 4.44444 8.97188V11H2.63889C2.40972 11 2.22222 11.1687 2.22222 11.375V11.625C2.22222 11.8313 2.40972 12 2.63889 12H4.44444V13.625C4.44444 13.8313 4.63194 14 4.86111 14H5.13889C5.36806 14 5.55556 13.8313 5.55556 13.625V12H7.36111C7.59028 12 7.77778 11.8313 7.77778 11.625V11.375C7.77778 11.1687 7.59028 11 7.36111 11H5.55556V8.97188C8.05556 8.725 10 6.81563 10 4.5ZM1.11111 4.5C1.11111 2.56562 2.84722 1 5 1C7.14931 1 8.88889 2.5625 8.88889 4.5C8.88889 6.43437 7.15278 8 5 8C2.85069 8 1.11111 6.4375 1.11111 4.5Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderMaleIcon);
export default __webpack_public_path__ + "static/media/gender-male-icon.18b8af3d2e33680ff8795708b7fc3d44.svg";
export { ForwardRef as ReactComponent };